import { $host } from "./index";

export const getAllRates = async () => {
    const {data} = await $host.get('web/accountpayment/all');
    return data;
}

export const getAccountInfo = async () => {
    const {data} = await $host.get('web/accountpayment/info/');
    return data;
}

export const getPaymentUrl = async (outSumm, Receipt) => {
    const { data } = await $host.post('web/accountpayment/url/', { outSumm, Receipt });
    return data;
}